export default __webpack_public_path__ + "static/media/13.61209556.webp";